// extracted by mini-css-extract-plugin
export var searchFeedbackSecondRow = "DBBTI";
export var searchFeedbackWithSort = "k14NU";
export var searchResultsText = "vW7j5";
export var searchThumbsFeedbackSecondRow = "rDNLF";